/* Feature flags */
export const AUTH_PASSWORD_LESS = true;
